import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";


import {  Apitoken, Authtoken } from '../Global';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const ProcurementSupplierAdd = () => {
  const [backendErrors, setBackendErrors] = useState([]);
 
  const [statusOptions, setStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});

  const [menu, setMenu] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      supplier_type: "",
      address: "",
      contact_person: "",
      phone_number: "",
      bank_number: "",
      bank_name: "",
      if:"",
      ice:"",
      note: "",
    },
    onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/procurementsupplier/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Add Supplier");
          delete backendErrors['error'];
          //actions.setSubmitting(false);

          if (response.data.code === 200) {
           
            toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/procurementsuppliers";
            }, 1000);
          }  else if (response.data.code === 422) {
            setSubmitting(false);
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setSubmitting(false);
            setBackendErrors(response.data.error);
          }
          else {
            setSubmitting(false);
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error)
         // actions.setSubmitting(false);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  useEffect(() => {
        setPermission(FindModuleById(439)); 

        axios.get("/helpers/trader-farmer-supplier-types", {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if(response.data.code === 200){
            let supplier_types = response.data.data.types;
           // setPackagingTypesLists(materials_payment_status);
            let supplier_typesList = supplier_types.map((ord, index) => ({
              label:  ord.title ,
              value: ord.id,
              key: `supplier-${index}`,
            }));
            setStatusOptions(supplier_typesList);
        }else{
            console.log("API response is not an array");
          }
                  
        })
        .catch((error) => {
          console.log(error);
        });

}, []);
const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};
const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Procurement Suppliers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/procurementsuppliers">ProcurementSuppliers</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Supplier</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Supplier  Information</h4>
                    {permission && permission.add == 1 && (
                    <FormikProvider value={formik}>
                    <form action="#" onSubmit={formik.handleSubmit}>
                     
                     <div className="row">
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Name</label>
                           <input
                             type="text"
                             name="name"
                             value={formik.values.name}
                             className={
                               backendErrors.name
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                          <small>
                             {backendErrors.name && (
                               <span className="form-error mt-1">
                                 {backendErrors.name}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
                       <div className="col-md-6">
                         <div className="form-group status">
                           <label>Supplier Type</label>
                           <Select
                          className="w-100"
                          value={statusOptions.find(option => option.value == formik.values.supplier_type) || null} // Ensure correct format
                          name="supplier_type"
                          onChange={(selectedOption) => {
                          handleSelectChange("supplier_type", selectedOption);
                        //   generateLotNumberLocation(selectedOption.value);
                          }}
                          onBlur={formik.handleBlur}
                          options={statusOptions}
                          placeholder="Select"

                            //  className={
                            //    backendErrors.supplier_type ? "w-100 input-error" : "w-100"
                            //  }
                            //  data={statusOptions}
                            //  value={formik.values.supplier_type}
                            //  name="supplier_type"
                            //  onChange={formik.handleChange}
                            //  onBlur={formik.handleBlur}
                            //  options={{
                            //    placeholder: "Select Supplier",
                            //  }}
                           />
                           <small>
                             {backendErrors.supplier_type && (
                               <span className="form-error mt-1">
                                 {backendErrors.supplier_type}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                       <div className="col-md-12">
                         <div className="form-group">
                           <label>Address</label>
                           <input
                             type="text"
                             name="address"
                             value={formik.values.address}
                             className={
                               backendErrors.address
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.address && (
                               <span className="form-error mt-1">
                                 {backendErrors.address}
                               </span>
                             )}
                           </small>
                         </div>
                         </div>
                         <div className="col-md-6">
                         <div className="form-group">
                           <label>Phone Number</label>
                           <input
                             type="text"
                             name="phone_number"
                             value={formik.values.phone_number}
                             className={
                               backendErrors.phone_number
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                           <small>
                             {backendErrors.phone_number && (
                               <span className="form-error mt-1">
                                 {backendErrors.phone_number}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Contact Person</label>
                           <input
                             type="text"
                             name="contact_person"
                             value={formik.values.contact_person}
                             className={
                               backendErrors.contact_person
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.contact_person && (
                               <span className="form-error mt-1">
                                 {backendErrors.contact_person}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>

                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Bank Number</label>
                           <input
                              type="text"
                           onKeyPress={(event) => {
                             // Allow only numbers (0-9)
                             if (!/^[0-9]$/.test(event.key)) {
                             event.preventDefault();
                             }
                           }}
                             name="bank_number"
                             value={formik.values.bank_number}
                             className={
                               backendErrors.bank_number
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.bank_number && (
                               <span className="form-error mt-1">
                                 {backendErrors.bank_number}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>

                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Bank Name</label>
                           <input
                             type="text"
                             name="bank_name"
                             value={formik.values.bank_name}
                             className={
                               backendErrors.bank_name
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.bank_name && (
                               <span className="form-error mt-1">
                                 {backendErrors.bank_name}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
                       
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>IF</label>
                           <input
                             type="text"
                             name="if"
                             value={formik.values.if}
                             className={
                               backendErrors.if
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.if && (
                               <span className="form-error mt-1">
                                 {backendErrors.if}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
                       
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>ICE</label>
                           <input
                             type="text"
                             name="ice"
                             value={formik.values.ice}
                             className={
                               backendErrors.ice
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.ice && (
                               <span className="form-error mt-1">
                                 {backendErrors.ice}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>


                       <div className="col-md-12">
                         <div className="form-group">
                           <label>Note</label>
                           <textarea
                            
                             name="note"
                             value={formik.values.note}
                             className={
                               backendErrors.note
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                               {backendErrors.note && (
                                 <span className="form-error mt-1">
                                   {backendErrors.note}
                                 </span>
                               )}
                           </small>
                         </div>
                       
                       </div>
                     </div>
                     <small>
                             {backendErrors.status  && (
                               <span className="form-error mt-1">
                                 {backendErrors.status}
                               </span>
                             )}

                          
                         
                           </small>
                     <div className="text-end mt-4">
                       <button
                         type="submit" id="form-submit"
                         className="btn btn-primary"
                         disabled={formik.isSubmitting}
                       >
                         Add Supplier
                       </button>
                     </div>
                   </form>
                    </FormikProvider>
                    
                    )}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProcurementSupplierAdd;
